// extracted by mini-css-extract-plugin
export default {"boxDescription":"LandingProduct_boxDescription__MeJjx"};